<industrial-gateway
  [measurementsOptions]="deviceMeasurements"
  [params]="schema.commands['sendCommand']"
  [configuration]="configuration"
  [command]="'sendCommand'"
  (onExecute)="executeCommand.emit($event)"
  #industrialGateway
></industrial-gateway>
